import { normalizeSearchNode, normalizeSearchText } from "./search_text.js"

const SEARCHABLE_NAMES = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "li", "blockquote", "figcaption", "dt", "dd", "td", "th", "pre"]
const CONTEXT_LENGTH = 80
const QUOTE_LENGTH = 200

export function searchableBlocks(document) {
  const body = document.body || Array.from(document.getElementsByTagName("*")).find((element) => element.localName === "body")
  if (!body) return []
  if (Array.from(body.childNodes).some((node) => node.nodeType === 3 && normalizeSearchText(node.nodeValue))) return [body]

  const descendants = []
  const collectDescendants = (element) => Array.from(element.childNodes).forEach((child) => {
    if (child.nodeType !== 1 || ["script", "style"].includes(child.localName)) return
    descendants.push(child)
    collectDescendants(child)
  })
  collectDescendants(body)
  const semanticCandidates = descendants.filter((element) => SEARCHABLE_NAMES.includes(element.localName))
  const semanticBlocks = semanticCandidates.filter((element) => !semanticCandidates.some((candidate) => element !== candidate && element.contains(candidate)))
  if (semanticBlocks.length > 0) return semanticBlocks

  const leafElements = descendants.filter((element) => !Array.from(element.childNodes).some((node) => node.nodeType === 1))
  return leafElements.length > 0 ? leafElements : [body]
}

export function rangeForLocator(document, locator) {
  const block = searchableBlocks(document)[Number(locator.block_index)]
  if (!block) return null

  const normalized = normalizeSearchNode(block)
  const quote = normalizeSearchText(locator.quote)
  const startOffset = Number(locator.start_offset)
  if (normalized.text.slice(startOffset, startOffset + quote.length) !== quote) return null

  const start = normalized.map[startOffset]
  const finish = normalized.map[Number(locator.end_offset) - 1]
  if (!start || !finish) return null

  const range = document.createRange()
  range.setStart(start.node, start.startOffset)
  range.setEnd(finish.node, finish.endOffset)
  return range
}

export function locatorForRange(section, range, exactText = null) {
  const document = range.startContainer.ownerDocument
  const blocks = searchableBlocks(document)
  const blockIndex = blocks.findIndex((block) => block.contains(range.startContainer))
  if (blockIndex < 0) return null

  const block = blocks[blockIndex]
  const normalizedBlock = normalizeSearchNode(block).text
  const startOffset = boundaryOffset(block, range.startContainer, range.startOffset)
  if (startOffset == null) return null

  const exact = (exactText || range.toString()).trim()
  const normalizedExact = normalizeSearchText(exact)
  const quote = exact ? exact.slice(0, QUOTE_LENGTH) : normalizedBlock.slice(startOffset, startOffset + QUOTE_LENGTH)
  if (!quote) return null
  const length = normalizedExact.length || normalizeSearchText(quote).length

  return {
    format: "epub",
    source: { href: section.href },
    block_index: blockIndex,
    start_offset: startOffset,
    end_offset: startOffset + length,
    quote,
    prefix: normalizedBlock.slice(Math.max(0, startOffset - CONTEXT_LENGTH), startOffset),
    suffix: normalizedBlock.slice(startOffset + length, startOffset + length + CONTEXT_LENGTH)
  }
}

function boundaryOffset(block, container, offset) {
  try {
    const range = block.ownerDocument.createRange()
    range.selectNodeContents(block)
    range.setEnd(container, offset)
    return normalizeSearchText(range.toString()).length
  } catch (_error) {
    return null
  }
}
